import React, { useRef, useCallback, useState, useEffect } from "react";
import { downloadImage } from "../../utils/captureImage";
import styles from "./PromoMaterials.module.scss";

const PromoCard = ({ label, filename, format, width, height, children, captureRef }) => {
  const innerRef = useRef(null);
  const wrapperRef = useRef(null);
  const ref = captureRef || innerRef;

  const [previewWidth, setPreviewWidth] = useState(Math.min(400, window.innerWidth - 48));

  useEffect(() => {
    const updateWidth = () => {
      if (wrapperRef.current) {
        const available = wrapperRef.current.offsetWidth - 32; // subtract card padding
        setPreviewWidth(Math.min(400, available));
      } else {
        setPreviewWidth(Math.min(400, window.innerWidth - 48));
      }
    };
    updateWidth();
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  const scale = previewWidth / width;
  const previewHeight = height * scale;

  const handleDownload = useCallback(async () => {
    if (!ref.current) return;
    try {
      await downloadImage(ref.current, filename, format, { width, height });
    } catch (error) {
      console.error(`Failed to download ${filename}:`, error);
    }
  }, [ref, filename, format]);

  return (
    <div ref={wrapperRef} className={styles.cardWrapper}>
      <span className={styles.cardLabel}>{label}</span>
      <div
        className={styles.cardPreview}
        style={{
          width: previewWidth,
          height: previewHeight,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            transform: `scale(${scale})`,
            transformOrigin: "top left",
          }}
        >
          <div ref={ref}>{children}</div>
        </div>
      </div>
      <div className={styles.cardActions}>
        <button onClick={handleDownload}>Download {format.toUpperCase()}</button>
      </div>
    </div>
  );
};

export default PromoCard;
